export class RolesModel {
  id: number;
  description: string;
}